import { useState } from "react";
import { useHistory } from "react-router-dom";

import DefRoutes from "../../routes/routes.json";
import t, { i18n } from "../../i18n/i18n";
import initPage from "../../utils/initPage";
import useApi from "../../services/api";

import Template from "../../template/template";
import Header from "./header/header";
import Server from "../../components/servers/servers";
import Notify from "../../components/notification/notify";
import MyRequests from "./myRequests/myRequests";
import { useSelector } from "react-redux";

function Request() {
  initPage({ title: "" });
  const { user } = useSelector((store) => store.auth);
  const { name, email } = user;
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const { push } = useHistory();
  const { ApiCreateTicket } = useApi();

  const [form, setForm] = useState({ files: [], name, email, date: new Date().toLocaleDateString() });

  function handleInputChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function handleFileAdd(e) {
    const { files } = form;

    console.log(e.target.files);

    const reader = new FileReader();

    reader.readAsDataURL(e.target.files[0]);

    reader.onload = async (event) => {
      const data = {
        file: event.target.result,
        name: e.target.files[0].name,
        size: e.target.files[0].size,
      };

      files.push(data);

      setForm({ ...form, files });
    };
  }

  function removeFile(i) {
    const { files } = form;

    files.splice(i, 1);

    setForm({ ...form, files });
  }

  async function onSelectServer(e) {
    setForm({ ...form, server: e.target.value });
  }

  async function SubmitForm(e) {
    e.preventDefault();

    if (!form.name) return Notify({ type: "danger", message: t("Errors.EmptySupportName") });
    if (!form.email) return Notify({ type: "danger", message: t("Errors.EmptySupportEmail") });
    if (!form.question) return Notify({ type: "danger", message: t("Errors.EmptySupportQuestion") });

    setLoadingSubmit(true);

    const { data } = await ApiCreateTicket({ ...form, lang: i18n.currentLocale(), status: "" });

    console.log(data);

    // Notify({ type: "success", message: t("Success.TicketCreated") });

    setForm({ files: [] });
    setLoadingSubmit(false);

    push(DefRoutes.SupportSuccess);
  }

  return (
    <Template>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="support-warp">
              <div className="support-warp-main">
                <Header />

                <div className="support-content">
                  {/* <div className="support-search">
                    <h4>PESQUISAR NA CENTRAL DE SUPORTE</h4>
                    <div className="input-text icon-search">
                      <input type="text" value="" pattern="" />
                    </div>
                  </div> */}

                  <div className="support-form">
                    {/* support-form */}

                    <div className="support-form-header">
                      <h1>{t("Support.Menu.Request")}</h1>
                    </div>

                    <div className="support-form-data">
                      <div className="form-data-box">
                        <form onSubmit={SubmitForm}>
                          <div className="input-box">
                            <input
                              type="text"
                              onChange={handleInputChange}
                              value={form.name || ""}
                              name="name"
                              placeholder={t("RequestForm.Name")}
                            />
                          </div>
                          <div className="input-box">
                            <input
                              type="text"
                              onChange={handleInputChange}
                              value={form.email || ""}
                              name="email"
                              placeholder={t("RequestForm.Email")}
                            />
                          </div>
                          <div className="input-box">
                            <Server simple onSelect={onSelectServer} />
                          </div>
                          <div className="input-box">
                            <input
                              type="text"
                              onChange={handleInputChange}
                              value={form.character || ""}
                              name="character"
                              placeholder={t("RequestForm.Character")}
                            />
                          </div>
                          <div className="input-box">
                            <input
                              type="text"
                              onChange={handleInputChange}
                              value={form.date || ""}
                              name="date"
                              placeholder={t("RequestForm.Date")}
                            />
                          </div>
                          <div className="input-box exclamation-text">
                            <p
                              dangerouslySetInnerHTML={{
                                __html: t("RequestForm.Alert"),
                              }}
                            />
                          </div>
                          <div className="input-box input-textarea no-bg">
                            <textarea
                              placeholder={t("RequestForm.Question")}
                              name="question"
                              onChange={handleInputChange}
                              value={form.question || ""}
                            />
                          </div>
                          <div className="input-box input-upload no-bg">
                            <div className="input-custom-upload">
                              <input type="file" onChange={handleFileAdd} />
                              <div className="upload-warp">
                                <div className="upload-style">
                                  <span className="upload-icon">
                                    <img src="/images/upload-ico.png" alt="" />
                                  </span>
                                  <h6>{t("RequestForm.Upload")}</h6>
                                  <p>{t("RequestForm.UploadDescription")}</p>
                                </div>
                              </div>
                            </div>
                          </div>

                          <ul className="black">
                            {form.files.map((F, i) => {
                              return (
                                <li className="black">
                                  {F.name}
                                  <img
                                    src="/images/close.png"
                                    alt=""
                                    className="remove-image"
                                    onClick={() => removeFile(i)}
                                  />
                                </li>
                              );
                            })}
                          </ul>

                          <div className="input-button">
                            <button type="button" className="btn btn-secondary btn-clear" onClick={() => push("/")}>
                              {t("RequestForm.Cancel")}
                            </button>
                            <button disabled={loadingSubmit} type="submit" className="btn btn-primary">
                              {t("RequestForm.Submit")}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                    <MyRequests />
                    {/* support-form */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Template>
  );
}

export default Request;
